import { useTranslate } from 'hooks/useTranslate';
import { setModal } from 'modules/_shared/redux/modalActions';
import { updateSociety } from 'modules/society/redux/societyActions';
import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { store } from 'redux/store';
import Swal from 'sweetalert2';

function ChangeFolderNameModal({ actualSociety, currentFolder }) {
  const { t } = useTranslate();

  const [folderName, setFolderName] = useState();

  function saveFolder() {
    const newFoldersData = actualSociety?.myFolders.map((folder) => {
      if (folder['_id'] === currentFolder['_id']) {
        return { ...folder, label: folderName };
      }
      return folder;
    });

    store.dispatch(
      updateSociety(
        actualSociety['_id'],
        {
          myFolders: newFoldersData,
        },
        false
      )
    );
    store.dispatch(setModal(null));
    return Swal.fire({
      icon: 'success',
      title: `<h4 class="nk-modal-title">${t(
        'FolderNameUpdatedSuccessfully'
      )}<br></h4>`,
      confirmButtonText: t('OK'),
      allowOutsideClick: false,
      showCancelButton: false,
      confirmButtonColor: '#6576FF',
    });
  }
  return (
    <>
      <Modal.Header>
        <h5>{t('UpdateFolder')}</h5>
        <a className="close" onClick={() => store.dispatch(setModal(null))}>
          <em className="icon ni ni-cross" />
        </a>
      </Modal.Header>

      <Modal.Body>
        <form className="form-validate is-alter" onSubmit={saveFolder}>
          <div className="form-group">
            <label className="form-label" htmlFor="full-name">
              {t('EnterNewName')}
            </label>
            <div className="form-control-wrap">
              <input
                type="text"
                className="form-control"
                value={folderName}
                onChange={(event) => setFolderName(event.target.value)}
              />
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-lg btn-primary"
            disabled={!folderName}
          >
            {t('Save')}
          </button>
        </form>
      </Modal.Body>
    </>
  );
}

export default ChangeFolderNameModal;
